module.exports = __webpack_public_path__ + "img/discover.952361da.svg";